// Single source of truth for every off-SPA URL.
//
// The three rungs of BriefBlip do not all live in this bundle. Meetings and Blip
// are React routes; the weekly archive (/weekly, /weekly/<issue>) and the brief
// permalinks (/b/<slug>) are rendered by ai-portal on chloe — api/briefblip/
// weekly.php and view.php — and reach briefblip.com through the reverse proxy.
// Link to those with a plain <a> so the browser does a full document navigation;
// a client-side <Link> would ask the router for a route that deliberately does
// not exist here.

export const COMPANY = 'Blue Note Logic Inc.';
export const COMPANY_URL = 'https://bluenotelogic.com';
export const TAGLINE = 'Brief anything, in a blip';

export const SITE_ORIGIN = 'https://briefblip.com';

/** Public archive of published weekly issues (api/briefblip/weekly.php). */
export const WEEKLY_ARCHIVE_URL = '/weekly';

/**
 * Permalink for a saved blip. The backend mints and returns the canonical URL on
 * its terminal event — prefer that. This is the fallback for a result that
 * carried a slug but no url.
 */
export function blipPermalink(slug: string): string {
  return `${SITE_ORIGIN}/b/${encodeURIComponent(slug)}`;
}
